<div class="handover">
    <img *ngIf="action.from" mat-card-avatar [src]="action.from | realtor" [matTooltip]="action.from | realtorTooltip" />
    <mat-icon>east</mat-icon>
    <img *ngIf="action.to" mat-card-avatar [src]="action.to | realtor" [matTooltip]="action.to | realtorTooltip" />
</div>